import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    root: {
        bottom: 0,
        position: 'fixed',
        width: '100%',
    },
    divider: {
        margin: 10
    },
    header: {
        backgroundColor: theme.palette.primary.main
    },
    routing: {
        color: theme.palette.primary.contrastText,
        borderColor: theme.palette.primary.contrastText,
        paddingRight: 5,
        paddingBottom: 5
    },
    contactUser: {
        color: theme.palette.primary.contrastText,
        borderColor: theme.palette.primary.contrastText,
        textAlign: 'left',
        paddingLeft: 5
    },
    gridPaymentType: {
        boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
        marginLeft: 20,
        marginRight: 20,
        marginTop: 10,
        borderRadius: 5,
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 10,
        display: 'flex',
        flexDirection: 'row'
    },
    gridReplayIcon: {
        textAlign: 'left',
        paddingLeft: 5
    },
    replayIcon: {
        color: theme.palette.color.green,
    }
}))
